import { createQueryKeyStore } from '@lukemorales/query-key-factory';

export const hiringRequestQueries = createQueryKeyStore({
  hiringRequests: {
    scorecards: (hiringRequestId: number) => ({
      queryKey: [hiringRequestId],
    }),

    list: (districtId: number) => ({
      queryKey: [districtId],
    }),
    postHiringPoolApplicationStatuses: (districtId: number) => ({
      queryKey: [districtId],
    }),
  },
});
